/*
 * Event properties must never carry personal data (see the funnel spec: email only on the person
 * profile via identify). This is the last line of defence for every event sent from the funnel
 * tracker: it drops keys that name personal fields, drops values that look like an email, and
 * reduces URLs to origin + path.
 */
const PII_KEY =
  /(^|_)(e-?mail|phone|mobile|first_?name|last_?name|full_?name|user_?name|address|password|token)$/i;
const EMAIL_LIKE = /[^\s@]+@[^\s@]+\.[^\s@]+/;

const stripUrl = (value: string) => {
  if (!/^https?:\/\//i.test(value)) return value;
  try {
    const url = new URL(value);
    return `${url.origin}${url.pathname}`;
  } catch {
    return value;
  }
};

export const scrubProperties = (properties: Record<string, unknown> = {}) => {
  const clean: Record<string, string | number | boolean> = {};
  for (const [key, value] of Object.entries(properties)) {
    if (PII_KEY.test(key) || value === undefined || value === null) continue;
    if (typeof value === "number" || typeof value === "boolean") clean[key] = value;
    else if (typeof value === "string" && !EMAIL_LIKE.test(value)) clean[key] = stripUrl(value);
  }
  return clean;
};
